// extracted by mini-css-extract-plugin
module.exports = {"base":"NoPermissions_base__QKanc","icon":"NoPermissions_icon__1u55a","message":"NoPermissions_message__2pzR0"};